import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'nl2br',
  standalone: false,
})
export class Nl2BrPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, sanitize: boolean = false): string | SafeHtml {
    if (!value) {
      return value;
    }

    // Replace newlines with <br> tags
    const result = value.replace(/\n/g, '<br>');

    // If sanitize is true, return sanitized HTML
    if (sanitize) {
      return this.sanitizer.sanitize(1, result) || '';
    }

    return result;
  }
}
